import { useAuth } from "./context/authContext";
import { useEffect, useState } from "react";
import {
  Appid,
  BaseUrl,
  Imei,
  LoginTypeID,
  SerialNo,
  Version,
} from "./enum/enum";
import axios from "axios";
import Layout from "./layout/layout";
import { useLoader } from "./context/loaderContext";

const ContractComp = () => {
  const { token, sessionId, userId } = useAuth();
  const { showLoader, hideLoader } = useLoader();

  const [dashboardUserAndBalanceData, setDashboardUserAndBalanceData] =
    useState({});

  useEffect(() => {
    getDashboardUserAndBalanceData();
  }, []);

  const getDashboardUserAndBalanceData = async () => {
    try {
      showLoader();
      const url = `${BaseUrl}Dashboard/GetManualContract`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
      };

      const res = await axios.post(url, obj);

      if (res.data.statuscode == 1) {
        setDashboardUserAndBalanceData(res.data.data);
      }
      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
    }
  };

  return (
    <Layout>
      <div className="row">
        <div className="col-12">
          <h4 className="view-contract-heading">View Contract</h4>
        </div>

        <div className="col-12">
          <div className="stats-row">
            <div className="stat-card">
              <div className="icon users">👥</div>
              <p className="title">Users</p>
              <h3 className="value">
                {dashboardUserAndBalanceData?.totalUsers}
              </h3>
            </div>

            <div className="stat-card">
              <div className="icon inputs">⬇</div>
              <p className="title">Inputs</p>
              <h3 className="value">
                ${dashboardUserAndBalanceData?.totalTopup}
              </h3>
            </div>

            <div className="stat-card">
              <div className="icon outputs">⬆</div>
              <p className="title">Outputs</p>
              <h3 className="value">
                ${dashboardUserAndBalanceData?.totalIncomeDistributed}
              </h3>
            </div>

            <div className="stat-card">
              <div className="icon balance">📊</div>
              <p className="title">Balance</p>
              <h3 className="value">${dashboardUserAndBalanceData?.balance}</h3>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContractComp;
